import { render, staticRenderFns } from "./system.vue?vue&type=template&id=42045ffd&scoped=true"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"
import style0 from "./system.vue?vue&type=style&index=0&id=42045ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42045ffd",
  null
  
)

export default component.exports